export default "/assets/images/mila-sock-without.f95e3b3cbc4b5776.png";